import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { BaseCareElement } from "./BaseCareElement";
import { CareElementType } from "./CareElementType";

export class TextCareElement extends BaseCareElement {
    public Name: string;
    public Value?: string | null;
    public CareElementType: CareElementType.Text;

    public constructor(init?: NonFunctionProperties<TextCareElement>) {
        super();
        this.CareElementType = CareElementType.Text;
        this.Name = init?.Name ?? "";
        this.Value = init?.Value ?? null;
        this.SubSectionName = init?.SubSectionName ?? "";
    }
}
